import { type ReactNode } from 'react';
import { View } from 'react-native';
import { clsx } from 'clsx';
import { useIllustrationScale } from './use-illustration-scale';

export type IllustrationScale = (value: number) => number;

type SceneLayer = (scale: IllustrationScale) => ReactNode;

export function IllustrationScene({
  transparent = false,
  background,
  children,
}: {
  transparent?: boolean;
  background?: SceneLayer;
  children: SceneLayer;
}) {
  const { handleLayout, s } = useIllustrationScale(160);

  return (
    <View
      onLayout={handleLayout}
      accessibilityElementsHidden
      importantForAccessibility="no-hide-descendants"
      className={clsx('relative aspect-square w-full overflow-hidden', {
        'bg-brand-green-light rounded-lg': !transparent,
      })}
    >
      {background && (
        <View pointerEvents="none" className="absolute inset-0">
          {background(s)}
        </View>
      )}
      {children(s)}
    </View>
  );
}
